// extracted by mini-css-extract-plugin
export default {"blueButton":"editOrderButton_blueButton__nxUzc","tooltipFontSize":"editOrderButton_tooltipFontSize__1czPV"};